// Lib
import React, { useCallback } from 'react';
import { Box, Rating as MuiRating } from '@mui/material';
import Typography from '@mui/material/Typography';

// Styles
import { colors } from '../../styles/palette';
import { useStyles } from './MyRatingStyles';

// Hooks
import useUser from '../../hooks/useUser';
import useRating from '../../hooks/useRating';

const MyRating = ({
  product,
  className,
  withTitle = true,
  updateProductRating,
}) => {
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({ isKiteUser });
  const { myRate, canRate, setRate } = useRating(product);

  const onChange = useCallback(
    (event, newValue) => {
      const updateRate = updateProductRating
        ? updateProductRating(product.product_id)
        : setRate;
      !!newValue && updateRate(newValue);
    },
    [setRate, updateProductRating, product.product_id],
  );

  return (
    <Box
      display="flex"
      alignItems="center"
      width="max-content"
      className={cx(classes.myRate, className)}>
      {withTitle ? 'My Rating' : ''}
      <MuiRating
        disabled={!canRate}
        id="rateable"
        name="simple-controlled"
        value={myRate}
        onChange={onChange}
      />
      <Typography color={colors.grey2} component="legend">
        {`${myRate}/5`}
      </Typography>
    </Box>
  );
};

export default MyRating;
